var _style, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBanconacion = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0E7391;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M430.5,500h-361C31.1,500,0,468.9,0,430.5v-361C0,31.1,31.1,0,69.5,0h361C468.9,0,500,31.1,500,69.5v361 C500,468.9,468.9,500,430.5,500z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M394.1,416.9c0,0.4-0.3,0.8-0.7,0.8l-287.1-0.1c-0.4,0-0.8-0.4-0.7-0.8l0-28.9c0-0.4,0.3-0.7,0.7-0.7 l287.2,0.1c0.3,0,0.7,0.4,0.7,0.7L394.1,416.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M200.8,341.3l0.1-145.5h33l0,145.5l32.1,0l0.1-145.5l32.9,0l-0.1,145.5l32.9,0l0.1-145.5l32.9,0l-0.1,145.5 h14.6l0,29.6c0,0.4-0.3,0.7-0.8,0.7l-257.3-0.1c-0.4,0-0.8-0.3-0.8-0.8l0-29.6H135l0.1-145.5l32.8,0v145.5L200.8,341.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M403.4,163.7L251,82.6c-0.5-0.3-1.4-0.3-1.9,0L96.6,163.7c-0.5,0.2-0.7,0.9-0.4,1.4l9.1,16 c0.3,0.5,1,0.9,1.6,0.9l286.4,0.1c0.6,0,1.3-0.4,1.6-0.9l9.1-16C404.1,164.7,404,164,403.4,163.7z M323.6,154.6l-147.3-0.1 c-0.6,0-0.6-0.2-0.1-0.4l72.8-35.5c0.6-0.3,1.2-0.3,1.5-0.2c0.3,0.1,0.9,0.5,1.4,0.7l71.8,35.1 C324.3,154.4,324.2,154.6,323.6,154.6z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBanconacion);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BANCONACION.a193feef57bc1e16ec20865a5519c5da.svg";